import api from './api';

const partnerValidationService = {
  // Validar si un email ya existe en la base de datos
  validateEmail: async (email) => {
    try {
      if (!email || email.trim() === '') {
        throw new Error('El email es requerido para la validación');
      }

      const response = await api.get('/api/PartnerValidation/validate-email', {
        params: { email: email.trim() }
      });
      
      return response.data;
    } catch (error) {
      console.error('Error al validar email:', error);
      throw error;
    }
  }
};

export default partnerValidationService;
